// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"4e3a3f9e","453":"04689deb","941":"3f138134","967":"fb600274"}[chunkId] + ".chunk.js";
};